<template>
  <v-card class="forgot-pwd-com mx-auto pa-3 mt-5" max-width="430">
    <v-card-text>
      <div class="forgot-pwd-content" v-if="!commitFlag">
        <div class="d-flex justify-space-between" style="margin-bottom: 10px;">
          <p class="card-title">{{ $t('login.userActivation') }}</p>
          <div class="close-btn" @click="navigatePush('home')">&times;</div>
        </div>

        <ValidationObserver ref="observer" v-slot="{ invalid, passes }">
          <!-- Password Field -->
          <ValidationProvider :name="$t('labels.pwd')" rules="required|pwdRule" vid="pwd" v-slot="{ errors }">
            <v-text-field
              v-model.trim="form_password.password"
              :label="$t('labels.acc.loginPwd.newPwd')"
              id="password"
              dense
              outlined
              clearable
              single-line
              :error-messages="errors[0]"
              :type="showPassword ? 'text' : 'password'"
              :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
              @click:append="showPassword = !showPassword"
              tabindex="3"
              :disabled="commitFlag"
            >
            </v-text-field>
          </ValidationProvider>

          <!-- Confirm Password Field  -->
          <ValidationProvider :name="$t('labels.confirmPwd')" rules="required|confirmed:pwd" v-slot="{ errors }">
            <v-text-field
              v-model.trim="form_password.repwd"
              :label="$t('labels.confirmPwd')"
              id="confirmPassword"
              dense
              outlined
              clearable
              single-line
              :error-messages="errors[0]"
              :type="showConfirmedPwd ? 'text' : 'password'"
              :append-icon="showConfirmedPwd ? 'mdi-eye' : 'mdi-eye-off'"
              @click:append="showConfirmedPwd = !showConfirmedPwd"
              tabindex="4"
              :disabled="commitFlag"
            ></v-text-field>
          </ValidationProvider>

          <div class="submit-container">
            <v-btn
              class="btn-common opacity-btn white--text my-0"
              ref="submitBtn"
              :loading="form_password_loading"
              @click="passes(reactivateAcc)"
              depressed
              tabindex="5"
              :disabled="commitFlag"
              >{{ $t('labels.reset') }}</v-btn
            >
          </div>
        </ValidationObserver>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import index from './reactivation';

export default index;
</script>

<style lang="stylus" scoped>
@import "../common.styl"
</style>
